module.exports = __webpack_public_path__ + "assets/img/banner.1dec117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner.png
// module id = 210
// module chunks = 45